import { PeopleScreen } from '@/components/domain/members/PeopleScreen';

export default function PeopleOnlineScreen() {
  return <PeopleScreen listType="online" />;
}
